import { ordersClient } from "@core/clients";
import { TOrder } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { UNPAID_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

const useGetUnpaidOrdersId = (options?: UseQueryOptions<TOrder["id"][], any, TOrder["id"][], string[]>) => {
  return useQuery(
    ["orders-unpaid"],
    async () => {
      return await ordersClient.getUnpaidOrdersId();
    },
    {
      cacheTime: UNPAID_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: UNPAID_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetUnpaidOrdersId;
